import React from 'react'
import Header from './Header'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import { useTheme } from '../common/ThemeContext'

export default function Layout() {

  const { isActive, setActive, sidebarToggle, miniSidebar, isHovered, handleMouseEnter, handleMouseLeave } = useTheme();

  return (
    <div className={`main min-h-svh overflow-y-auto bg-bg-light ${isActive ? 'sidebar-open' : ''}`}>
      <div className='header bg-bg-dark border-b border-b-border xl:static sticky top-0 z-[3]'>
        <Header sidebarToggle={sidebarToggle} isActive={isActive} />
      </div>
      <div className='flex md:h-[calc(100svh-61px)] h-[calc(100svh-46.2px)]'>
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className={`${miniSidebar ? isHovered ? 'w-[250px]' : 'w-[70px]' : 'w-[250px]'} ${isActive ? 'left-0' : 'left-[-250px]'} ${miniSidebar ? 'border-r border-border bg-bg-dark' : 'bg-bg-light'} sidebar fixed xl:top-[61px] top-0 xl:h-[calc(100svh-61px)] z-[5] h-full overflow-y-auto no-scrollbar transition-all duration-500 ease-in-out`}
        >
          <Sidebar setActive={setActive} />
        </div>
        <div className={`main-content flex-1 xl:p-20 px-15 py-20 overflow-y-auto transition-all duration-500 ease-in-out ${isActive ? miniSidebar ? 'xl:pl-[90px]' : 'xl:pl-[270px]' : 'xl:pl-20'}`}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
